<template>

	<div class="wrapper" @click.stop="active=true">
		<div class="selected">{{handler}}</div>
		<div class="options" v-show="active">
			<div v-for="font in list" class="option" @click.stop="select(font.name)">
				<img :src="font.image" :alt="font.name">
			</div>
		</div>

	</div>


</template>

<style scoped>

.wrapper{ position: relative; }
.selected{ height:38px; background:#fff; color:#000; padding:10px; cursor:pointer; display: flex; align-items:center; justify-content:space-between; border-radius:4px; }
.selected:after { content:'›'; font-size:1.8em; line-height:1; display:inline-block; transform: rotate(90deg); }
.options{
	position:absolute;
	top:0; left:0;
	background:#fff;
	color:#000;
	min-width:100%;
	box-shadow:1px 1px 3px rgba(0,0,0,.5);
	border-radius:4px;
	max-height: 250px;
	max-height: 30vh;
	overflow: auto;
	z-index: 2;
}
.option{ padding:10px; cursor:pointer; }
.option + .option { border-top:1px solid #eee; }
.option:hover { background-color:#f1f1f1; border-radius:inherit; }
.option img { max-width:100%; max-height:16px; display:block; }


</style>

<script>

export default {
	props:['value'],
	data(){
		return {
			handler:'',
			active:false,
			list:[
				{ name:'Arvo', image:'/images/fonts/arvo.png' },
				{ name:'Barlow', image:'/images/fonts/barlow.png' },
				{ name:'Cinzel', image:'/images/fonts/cinzel.png' },
				{ name:'Courier Prime', image:'/images/fonts/courier-prime.png' },
				{ name:'Dancing Script', image:'/images/fonts/dancing-script.png' },
				{ name:'Indie Flower', image:'/images/fonts/indie-flower.png' },
				{ name:'Josefin Sans', image:'/images/fonts/josefin-sans.png' },
				{ name:'Montserrat', image:'/images/fonts/montserrat.png' },
				{ name:'Nunito', image:'/images/fonts/nunito.png' },
				{ name:'Open Sans', image:'/images/fonts/open-sans.png' },
				{ name:'Oswald', image:'/images/fonts/oswald.png' },
				{ name:'Pacifico', image:'/images/fonts/pacifico.png' },
				{ name:'Playfair Display', image:'/images/fonts/playfair-display.png' },
				{ name:'Prata', image:'/images/fonts/prata.png' },
				{ name:'Roboto', image:'/images/fonts/roboto.png' },
				{ name:'Sacramento', image:'/images/fonts/sacramento.png' },
			],

		}
	},
	methods:{
		select(name){
			this.handler = name;
			this.active = false;
			this.$emit('input',this.handler)
		}
	},
	mounted(){
		this.handler = this.value || 'left';
		document.body.addEventListener('click',()=>{ this.active = false; })
		document.body.addEventListener('keydown',(e)=>{ if(e.keyCode==27) this.active = false; })
	},


}
</script>
